<add-to-quote-menu *ngIf="addToQuoteMenu$ | async" [selectedQuote]="chosenQuote$ | async" [isLoading]="isLoading$ | async" [product]="product$ | async" [selectedQuantity]="selectedQuantity$ | async"></add-to-quote-menu>
<create-new-quote *ngIf="createNewQuote$ | async"></create-new-quote>
<choose-quote *ngIf="chooseQuote$ | async" [quotes]="quotes$ | async"></choose-quote>
<app-quotes-page *ngIf="quoteListMenu$ | async"></app-quotes-page>
<quote-order-complete *ngIf="quoteOrderComplete$ | async" [quote]="chosenQuote$ | async"></quote-order-complete>
